import React from 'react';

const Unsubscribe = (props) => {
    return (
        <div >
            <h2>Sorry to see you go!</h2>
            </div>
    )
}

export default Unsubscribe;